function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SidebarTemplate = require('./sidebar.template');
var Sidebar = /*#__PURE__*/function () {
  function Sidebar(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Sidebar);
    this.app = app;
    this.mod = mod;
    this.container = container;

    // Placeholder discovery list — same architecture as the prior Sidebar
    // implementation. No external recommendation module exists in production.
    this.suggestions = [{
      name: 'Saito Network',
      handle: 'saito',
      avatar: '/saito/img/dreamscape.png'
    }, {
      name: 'Alice Chen',
      handle: 'alice',
      avatar: '/saito/img/tiled-logo.svg'
    }, {
      name: 'Richard P.',
      handle: 'rp',
      avatar: '/saito/img/dreamscape.png'
    }];
  }
  return _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.app.browser.replaceElementContentBySelector(SidebarTemplate(this), this.container);
      this.renderModuleMounts();
      this.attachEvents();
    }

    /**
     * Ordered module injection — RedSquare owns sequence; peers own content.
     */
  }, {
    key: "renderModuleMounts",
    value: function renderModuleMounts() {
      var _this$app$modules;
      if (!((_this$app$modules = this.app.modules) !== null && _this$app$modules !== void 0 && _this$app$modules.renderInto)) {
        return;
      }
      this.app.modules.renderInto('.redsquare-arcade');
      this.app.modules.renderInto('.redsquare-leaderboard');
      this.app.modules.renderInto('.redsquare-sidebar');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = Sidebar;